import {Component, Input} from '@angular/core';
import {BaseChartComponent} from '@rsp/shared/component/graph/base-chart.component';
import {TenantsCommunityTotalDTO} from '@rsp/models/dto/tenants-community-totals.dto';
import * as Highcharts from 'highcharts';


@Component({
  selector: 'rsp-community-activity-chart',
  templateUrl: '../base-chart.component.html',

})
export class CommunityActivityChartComponent extends BaseChartComponent<TenantsCommunityTotalDTO[]> {

  public _showYesterday: boolean;

  constructor() {
    super();
  }

  @Input() set displayPreviousDay(show: boolean) {
    this._showYesterday = show;

    this.updateGraph();
  }

  render() {
    super.render();

    const supply = ((d: TenantsCommunityTotalDTO) => {
      return d !== undefined ? d.bioProduction + d.waterProduction + d.windProduction + d.pvProduction : 0;
    });

    const consumption = ((d: TenantsCommunityTotalDTO) => {
      return d !== undefined ? d.bioConsumption + d.waterConsumption + d.windConsumption + d.pvConsumption : 0;
    });

    if (this.chart.ref.series.length === 0) {
      const today: TenantsCommunityTotalDTO = this._data[1];

      this.chart.addSeries({
        type: 'column',
        name: 'Erzeugung',
        color: this.color1,
        data: [supply(today)]
      }, false, false);

      this.chart.addSeries({
        type: 'column',
        name: 'Verbrauch',
        color: this.color2,
        data: [consumption(today)]
      }, true, true);

    } else if (this._showYesterday) {
      const d: TenantsCommunityTotalDTO = this._data[0];

      this.chart.addSeries({
        type: 'column',
        name: 'Erzeugung Vortag',
        color: this.color4,
        data: [supply(d)]
      }, false, false);

      this.chart.addSeries({
        type: 'column',
        name: 'Verbrauch Vortag',
        color: this.color3,
        data: [consumption(d)]
      }, true, true);

    } else if (!this._showYesterday && this.chart.ref.series.length >= 4) {
      this.chart.removeSeries(2);
      this.chart.removeSeries(2);
    }
  }

  protected hasData(): boolean {
    return super.hasData() && this.data.length > 0;
  }

  protected createChartOptions(): Highcharts.Options {
    return {
      chart: {
        type: 'column',
        height: 250,
        marginLeft: 100
      },
      exporting: {
        enabled: false,
      },
      title: {
        text: ''
      },
      tooltip: {
        headerFormat: ' ',
        pointFormatter: function () {
          return BaseChartComponent.pointFormatter(this, 'kWh');
        }
      },
      yAxis: {
        title: {
          text: null
        },
        labels: {
          padding: 0,
          formatter: function () {
            if (this.value >= 999) {
              return (this.value as number / 1000).toFixed(0) + ' Tsd. kWh';
            } else if (this.value >= 999999) {
              return (this.value as number / 1000).toFixed(0) + ' M. kWh';
            } else {
              return this.value.toString();
            }

          }

        }
      },
      credits: {
        enabled: false
      },
      series: []
    };

  }
}
